import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from "react-ga4";

class W9RequestForm extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            input: {
                firstName: userExists ? props.location.state.user.firstname : '',
                lastName: userExists ? props.location.state.user.lastname : '',
                email: userExists ? props.location.state.user.email : '',
                phoneNumber: userExists ? props.location.state.user.phone : '',
                username: userExists ? props.location.state.user.username : '',
                accountNumber: ''
            },
            accounts: [],
            errors: {},
            loading: false
        };

        this.createSelectItems = this.createSelectItems.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showButton = this.showButton.bind(this);
    }

    handleFormChange(event) {
        let input = this.state.input;
        let errors = this.state.errors;
        input[event.target.name] = event.target.value;
        if (!!errors[event.target.name]) {
            errors[event.target.name] = null;
        }

        this.setState({
            input,
            errors
        });
    }

    validate() {
        let input = this.state.input;
        let errors = {};
        let isValid = true;

        if (!input["firstName"]) {
            isValid = false;
            errors["firstName"] = "Please enter your first name.";
        }
        if (!input["lastName"]) {
            isValid = false;
            errors["lastName"] = "Please enter your last name.";
        }

        if (!input["phoneNumber"]) {
            isValid = false;
            errors["phoneNumber"] = "Please enter your phone number.";
        }

        if (!input["email"]) {
            isValid = false;
            errors["email"] = "Please enter your email address.";
        }

        if (!input["entityType"]) {
            isValid = false;
            errors["entityType"] = "Please choose a day.";
        }

        this.setState({
            errors: errors
        });

        return isValid;
    }

    componentDidMount() {
        axios.get(`${Constants.apiURL}/api/Payment/accounts`, {
            params: {
                username: this.state.user.username,
                isWork: true
            }
        }).then(response => {
            if (response.data) {
                let input = this.state.input;
                input.accountNumber = response.data[0].accountID;
                this.setState(() => ({
                    accounts: response.data,
                    input: input
                }));
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    createSelectItems() {
        let items = [];
        items = this.state.accounts.map(function (item) {
            return <option value={item.accountID}>{item.accountID} | {item.accountName}</option>;
        });
        return items;
    }

    handleSubmit(event) {

        event.preventDefault();
        console.log(this.fileControl);
        if (!this.validate()) {
            alert('Please fill in required fields to proceed.');
            return;
        }

        let formData = new FormData();
        for (var key in this.state.input) {
            formData.append(key, this.state.input[key]);
        }
        formData.append('username', this.state.user.username);
        this.setState({ loading: true });


        axios.post(`${Constants.apiURL}/api/Request/w9`, this.state.input
        ).then(response => {
            if (response.data && response.data == true) {
                ReactGA.event({
                    category: 'Request',
                    action: 'W9',
                    label: ''
                });
                alert('Your W-9 request has been received, and should be processed within one (1) business day. We will reach out with any questions.');
                this.props.history.push({
                    pathname: '/orders',
                    state: {
                        user: this.state.user
                    }
                });
            }
            else {
                alert('Error processing your request');
            }
            this.setState({ loading: false });
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                Submit
            </Button>
        }
    }

    render() {
        return (
            <div>
                <SiteMenu user={this.state.user} currentPage='w9Request' />
                <Form onSubmit={this.handleSubmit} style={{ padding: 5 }} noValidate>
                    <Row className="form-row-first">
                        <Form.Label style={{ marginBottom: '0px' }} className="form-header">W-9 Request Form</Form.Label>
                        <Form.Label style={{ fontSize: '15px', marginTop: '-5px', paddingTop: '0px', fontStyle: 'italic' }}>
                            Provide request information below. A member of our team will process your request and call with any questions.
                        </Form.Label>
                        <Form.Label className="form-header">Requestor Information</Form.Label>
                        <Col md={6}>
                            <Form.Group className="mb-3" controlId="accountNumber" >
                                <Form.Label>Account Number</Form.Label>
                                <Form.Select name="accountNumber" onChange={this.handleFormChange}>
                                    {this.createSelectItems()}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formFirstname">
                                <Form.Label>First name</Form.Label>
                                <Form.Control type="input" name="firstName" value={this.state.input.firstName} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.firstName} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formLastname">
                                <Form.Label>Last name</Form.Label>
                                <Form.Control type="input" name="lastName" value={this.state.input.lastName} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.lastName} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control type="email" placeholder="Enter email" name="email" value={this.state.input.email} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.email} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formPhoneNumber">
                                <Form.Label>Phone number</Form.Label>
                                <Form.Control type="phone" name="phoneNumber" value={this.state.input.phoneNumber} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.phoneNumber} />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="form-row-first">
                        <Form.Label className="form-header">W-9 Request Information</Form.Label>
                        <Col md={6}>
                            <Form.Group className="mb-3" controlId="entityType">
                                <Form.Label>Entity</Form.Label>
                                <Form.Select name="entityType" value={this.state.input.entityType} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.entityType}>
                                    <option key='blankChoice' hidden value="">Please select one...</option>
                                    <option value="Boland">Boland</option>
                                    <option value="Parklawn">Parklawn</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Form.Group className="mb-3" controlId="formAdditionalInformation">
                            <Form.Label>Additional information</Form.Label>
                            <Form.Control as="textarea" rows={3} name="additionalInformation" value={this.state.input.additionalInformation} onChange={this.handleFormChange} />
                        </Form.Group>
                    </Row>
                    {this.showButton()}
                </Form>
            </div>
        );
    }
}

export default W9RequestForm;